import React from "react";

const TitleInput = ({ title, handleInputChange, error, editId }) => {
    const maxLength = 120;

    return (

        <>
            <div className="newtextparent">
                <h6>
                    Task Title <span>*</span>
                </h6>
                <p className="newpara">
                    {title.length}/{maxLength} Character
                </p>
            </div>
            
            <input
                type="text"
                className={editId ? 'disabledClass' : null}
                placeholder="Enter task title here..."
                value={title}
                maxLength={maxLength}
                disabled={editId}
                onChange={(e) => handleInputChange("title", e.target.value)}
            />
            {/* {error && <p className="error-message">{error}</p>} */}
        </>
    );
};

export default TitleInput;
